
import Swiper from "swiper";
import truncate from 'truncate-html'
import { debounce } from '../utils/helpers';

export default (element) => {

  const initTruncateText = () => {
    const truncatedElements = element.querySelectorAll('[data-truncated]')
    truncatedElements.forEach((el) => {
      const truncatedText = truncate(el.innerHTML, 200)
      // eslint-disable-next-line no-param-reassign
      el.innerHTML = `${truncatedText}`
    })
  }

  const toggleShowMore = () => {
    const showMoreButtons = element.querySelectorAll('[href="#more"]')
    showMoreButtons.forEach(btn =>
      btn.addEventListener('click', e => {
        e.preventDefault()
        const wrapper =
        element.querySelector(`[data-wrapper-index="${btn.dataset.index}"]`)
        wrapper.classList.toggle('show-more')
      })
    )
  }

  const init = () => {
    
    let swiper;
    
    const initSwiper = () => {
      const slider = element.querySelector('.swiper');
      swiper = new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 11,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
      });
    };
    
    const destroySwiper = () => {
      if (swiper !== undefined) {
        swiper.destroy(true, true);
      }
    };
    
    const checkViewport = () => {
      if (window.innerWidth > 1024 && swiper !== undefined) {
        destroySwiper();
      }
      // eslint-disable-next-line max-len
      else if (window.innerWidth <= 1024 && (swiper === undefined || swiper.destroyed)) {
        initSwiper();
      }
    };

    initTruncateText();
    toggleShowMore();
    checkViewport();
    window.addEventListener('resize', debounce(checkViewport, 200));
  };

  init();
};